import { Button } from '@commenda/kakashi';

interface IndirectTaxFilingsEmptyStateProps {
  // True when the corporation already has at least one active registration
  // in the current region. The empty state then prompts the user to generate
  // a calendar, not to go create a registration.
  hasRegistrations: boolean;
  onGoToRegistrations?: () => void;
  onGenerateCalendar?: () => void;
}

const IndirectTaxFilingsEmptyState = ({
  hasRegistrations,
  onGoToRegistrations,
}: IndirectTaxFilingsEmptyStateProps) => {
  const description = hasRegistrations
    ? 'We are currently working on generating upcoming filings for your registrations.'
    : 'Filings will appear here once you have active tax registrations.';

  return (
    <div className="flex flex-col items-center justify-center flex-1 py-11xl">
      <div className="flex flex-col items-center gap-xl">
        <div className="flex flex-col items-center gap-md">
          <h3 className="txt-large-bold text-text-primary">
            Filings will appear here
          </h3>
          <p className="txt-small-regular text-text-secondary">{description}</p>
        </div>
        {hasRegistrations ? null : (
          <Button variant="primary" size="md" onClick={onGoToRegistrations}>
            Go to registrations
          </Button>
        )}
      </div>
    </div>
  );
};

export { IndirectTaxFilingsEmptyState };
